// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3-YnZ","content":"LoadingAlert_content__3y1-_"};